import { render, staticRenderFns } from "./BookAnalyticsDetails.vue?vue&type=template&id=5c6a6062"
import script from "./BookAnalyticsDetails.vue?vue&type=script&lang=js"
export * from "./BookAnalyticsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports